import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as routes from '../../routes/routes';
import { Paper, Typography, Button, TextField } from '@material-ui/core';
import { auth } from '../../firebase';
import LoginPage from '../Login';
import firebase from 'firebase/app';
import { toast } from 'react-toastify';

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    email: '',
    password: '',
    loginError: null,
};
class VerifyEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validCode: null,
            verifiedCode: false,
            error: '',
            ableToLogin: false
        };
    }

    componentDidMount() {
        auth
            .applyActionCode(this.props.actionCode)
            .then(() => {
                this.setState({ validCode: true, verifiedCode: true });
                firebase.auth().currentUser.reload().then(() => {
                    if (firebase.auth().currentUser.emailVerified) {
                        setInterval(() => {
                            setTimeout(() => this.props.history.push(routes.DASHBOARD))
                        }, 3000)
                    } else {
                        this.setState({ ableToLogin: true })
                    }
                })
                    .catch(() => {
                        this.setState({ ableToLogin: true })
                    })
            }, error => {
                this.setState({ error: error.message, validCode: false, verifiedCode: true });
                setInterval(() => {
                    setTimeout(() => this.props.history.replace(routes.LOGIN))
                }, 3000)
            });
    }

    onSubmit = (event) => {
        const {
            email,
            password,
        } = this.state;

        const {
            history,
        } = this.props;

        auth.signInWithEmailAndPassword(email, password)
            .then((user) => {
                if (user.user.emailVerified === true) {
                    history.push(routes.DASHBOARD);
                } else {
                    user.user.sendEmailVerification().then(function () {
                        toast.error('Email not verified, please verify your email!A verification link has been sent to your email address! Please click the link to verify your account', {
                            position: 'top-center',
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });
                    })
                    this.setState(() => ({ ...INITIAL_STATE }));
                }
            })
            .catch((error) => {
                this.setState(updateByPropertyName('loginError', error));
            });

        event.preventDefault();
    }

    render() {
        const { validCode, verifiedCode, error, ableToLogin } = this.state
        const {
            email,
            password,
            loginError,
        } = this.state;

        const isInvalid = password === ''
            || email === '';
        return (
            <div className="padding-middle">
                <div style={{
                    textAlign: 'center',
                }}>
                    <Paper className="papper-middle">
                        {verifiedCode && validCode &&
                            <div>
                                <Typography variant="h4" color="primary" style={{ fontWeight: 'bold', paddingTop: '40px' }}>Your mail has been verified</Typography>
                                <Typography>You can now sign in with your new account.</Typography>
                            </div>
                        }
                        {error && <Typography className="message-error">{error}</Typography>}
                        {ableToLogin &&
                            <div>
                                <TextField
                                    label="Email"
                                    required
                                    onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
                                />
                                <br />
                                <TextField
                                    type="password"
                                    label="Password"
                                    required
                                    onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
                                />
                                <br />
                                <Button
                                    disabled={isInvalid}
                                    className="formButton"
                                    onClick={this.onSubmit}
                                >
                                    {'Login'}
                                </Button>
                            </div>
                        }
                        {loginError && <Typography className="message-error">{loginError.message}</Typography>}
                    </Paper>
                </div>
            </div>
        );
    }
}

export default withRouter(VerifyEmail);



// WEBPACK FOOTER //
// ./src/components/VerifyEmail/index.js